import { register } from 'swiper/element/bundle';

register();

// Initialize Swiper elements
document.addEventListener('DOMContentLoaded', () => {
  const swiperEls = document.querySelectorAll('swiper-container[init="false"]');

  swiperEls.forEach(swiperEl => {
    Object.assign(swiperEl, {
      slidesPerView: 1,
      navigation: true,
      loop: true,
      effect: 'creative',
      autoHeight: true,
      speed: 600,
      autoplay: {
        delay: 3500,
        disableOnInteraction: true,
      },
      creativeEffect: {
        prev: {
          shadow: true,
          translate: ["-20%", 0, -1],
        },
        next: {
          translate: ["100%", 0, 0],
        },
      },
      injectStyles: [
        `
          :host{
            --swiper-navigation-size: 24px;
            --swiper-navigation-color: var(--white);
          }
        `
      ]
    });

    // Initialize the Swiper
    swiperEl.initialize();
  });
});